import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { modalETLHelpOnChangeAction } from '../../../stores/actions/modalOnChange';

import etlService from '../../ModelLanding/ETL/etlService';
import './ETLHelpStyle.scss';

class ETLHelp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true,
        };

        this.etlService = new etlService();
    }

    /**
     * Get help content
     */
    getHelpContent() {
        const templateItems = this.props.templates.map((tplt, idx) => {
            const label = tplt.displayLabel;
            const row = (
                <tr key={`${tplt.fileType}-${idx}`}>
                    <td>{label}</td>
                    <td>
                        <a onClick={ () => this.etlService.getEtlTemplateDownloadUrl(tplt.fileTemplateId, tplt.name, tplt.fileExt)} href="javascript:void(0);">
                            Download {tplt.name}.{tplt.fileExt}
                        </a>
                    </td>
                    <td>{tplt.description}</td>
                </tr>
            );
            return row;
        });
        return (
            <>
                <h5>Data File Templates</h5>
                <table className="template-table">
                    <tbody>{templateItems}</tbody>
                </table>
            </>
        );
    }

    /**
     * Handle on close
     */
    handleClose = () => {
        this.setState({
            show: false,
        });
        this.props.setETLHelpClosed({ status: false });
    };

    /**
     * Ui elements rendering
     */
    render() {
        const { show } = this.state;

        return (
            <>
                <Modal className="modal-help" size="lg" show={show} onHide={this.handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Upload Templates</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="body-content">{this.getHelpContent()}</div>
                        <div className="body-footer text-right">
                            <Button type="button" className="submit-btn" size="sm" onClick={this.handleClose}>
                                OK
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

/**
 * Dispath props
 * @param {*} dispatch dispath props
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setETLHelpClosed: (params) => dispatch(modalETLHelpOnChangeAction(params)),
    };
};

ETLHelp.propTypes = {
    setETLHelpClosed: PropTypes.func.isRequired,
    templates: PropTypes.object,
};

/**
 * Mapping redux state into props
 */
const MapStateToProps = () => {
    return {};
};

export default connect(MapStateToProps, MapDispatchToProps)(ETLHelp);
